module.exports = __webpack_public_path__ + "static/EuclidCircularB-Regular-WebS-ccabc36c35965c065440b8060b25d22f.woff";